<template lang="html">
  <v-dialog v-model="dialog" fullscreen>
    <template v-slot:activator="{ on }">
      <v-btn color="secondary" v-on="on">
        Create new TAKT.step
      </v-btn>
    </template>
    <v-card>
      <v-toolbar dark color="secondary">
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>TAKT.step Editor</v-toolbar-title>
      </v-toolbar>
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="10" align="center" justify="center">
            <StandardTextfield
              color="color-1 lighten-2"
              icon="radio_button_unchecked"
              type="text"
              class="mb-2"
              style="width: 100%"
              :readonly="true"
              :value="getNewCustomWorkStep.text" />
          </v-col>
        </v-row>
      </v-container>

      <!-- <v-card-text> -->
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1">Set TAKT.step</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step step="2">Finalize TAKT.step</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card
                class="mb-12 pa-2"
                color="color-3"
                min-height="200px"
              >
                <v-row>
                  <v-col cols="12" class="ma-2 pa-2">
                    <h2>Set TAKT.step</h2>
                    <StandardTextfield
                      color="color-3 lighten-2"
                      icon="radio_button_unchecked"
                      type="text"
                      class="mb-2"
                      style="width: 100%"
                      :value="getNewCustomWorkStep.text"
                      placeholder="Your TAKT.step"
                      @changeValue="setNewCustomWorkStepText($event)" />
                  </v-col>
                </v-row>
              </v-card>

              <v-btn color="secondary" @click="nextStep()">Continue</v-btn>
              <v-btn disabled text>Step back</v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card
                class="mb-12 pa-2"
                color="color-3"
                min-height="200px"
              >
                <h2>Finalize TAKT.step</h2>
              <StandardFlagDropdown
              :value="getNewCustomWorkStep.country.name"
              color="secondary"
              :options="countries"
              @changeValue="setNewCustomWorkStepCountry($event)" />
              <StandardTextfield class="mt-5" color="secondary" placeholder="Hashtags"
                                 type="text" min="1" style="width: 50%"
                                 :value="getNewCustomWorkStepHashtags" @changeValue="updateHashtags($event)" />
              </v-card>

              <v-btn color="secondary" disabled>Continue</v-btn>
              <v-btn @click="stepBack()" text>Step back</v-btn>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      <!-- </v-card-text> -->
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
        <v-btn color="blue darken-1" :disabled="e1 !== 2" text @click="finishCreateDialog()">Accept</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import StandardTextfield from '@/components/StandardComponents/StandardTextfield.component.vue'
import StandardFlagDropdown from '@/components/StandardComponents/StandardFlagDropdown.component.vue'

import { getCountries } from '../../helpers/data';


export default {
  name: 'WorkStepEditorDialog',
  props: ['work_step_editor_dialog'],
  components: {
    StandardTextfield,
    StandardFlagDropdown,
  },
  data: () => ({
    dialog: false,
    e1: 1,
    countries: []
  }),
  created() {
    this.dialog = this.work_step_editor_dialog;
    this.countries = getCountries();
    this.countries.push({
      flag: 'other',
      name: 'Other'
    });
  },
  computed: {
    ...mapGetters('WorkStep', [
      'getNewCustomWorkStep'
    ]),
    getNewCustomWorkStepHashtags: function () {
      return this.getNewCustomWorkStep.hashtags.join(' ');
    }
  },
  methods: {
    stepBack(){
      if (this.e1 > 1) {
        this.e1--;
      }
    },
    nextStep(){
      this.e1++;
    },
    finishCreateDialog(){
      this.createCompleteWorkStep()
      .then(() => {
        this.dialog = false;
        this.e1 = 1;
      })
      .catch(() => {
      });
    },
    updateHashtags(hashtags){
      let hashtag_arr = hashtags.split(' ');
      for (var i = 0; i < hashtag_arr.length; i++) {
        if (hashtag_arr[i].startsWith('#')) {
          hashtag_arr[i] = hashtag_arr[i].substr(1);
        }
      }
      this.setNewCustomWorkStepHashtags(hashtag_arr);
    },
    ...mapActions('WorkStep', [
      'setNewCustomWorkStepText',
      'setNewCustomWorkStepCountry',
      'setNewCustomWorkStepHashtags',
      'createCompleteWorkStep'
    ])
  }
}
</script>

<style lang="css" scoped>
.picker-card {
  width: 58px;
  height: 38px;
  float: left;
  margin: 5px;
  cursor: pointer;
}
</style>
